import { Injectable } from '@angular/core';
import { SyssdServicePkg } from './syssdPkg.service';

@Injectable({
  providedIn: 'root',
})
export class SyssdService extends SyssdServicePkg {
  constructor() {
    super();
  }
}
